













































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'
import {ResponsavelConfigWhatsappCollection} from '@/model/collection/ResponsavelConfigWhatsappCollection'
import {ListResponsavelConfigWhatsappSchema} from '@/schema/resource/ResponsavelConfigWhatsapp/ListResponsavelConfigWhatsappSchema'
import {CsvResponsavelConfigWhatsappSchema} from '@/schema/resource/ResponsavelConfigWhatsapp/CsvResponsavelConfigWhatsappSchema'
import ModalApproveWhatsapp from '@/components/modals/ModalApproveWhatsapp.vue'
import ModalDisapproveWhatsapp from '@/components/modals/ModalDisapproveWhatsapp.vue'
import {StatusWhatsapp} from '@/model/resource/StatusWhatsapp'

@Component({
  components: {ModalDisapproveWhatsapp, ModalApproveWhatsapp},
})
export default class ListResponsavelConfigWhatsappView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelConfigWhatsappSchema()
  collection = new ResponsavelConfigWhatsappCollection()

  StatusWhatsapp = StatusWhatsapp

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelConfigWhatsapp) {
    Helper.pushByName('editResponsavelConfigWhatsapp', item.$id)
  }

  approve(item: ResponsavelConfigWhatsapp) {
    this.$modal.open('approveWhatsapp', item.$id)
  }

  disapprove(item: ResponsavelConfigWhatsapp) {
    this.$modal.open('disapproveWhatsapp', item.$id)
  }

  async removeItem(item: ResponsavelConfigWhatsapp) {
    await new DialogRemove(item).confirm(() =>
      item.removeResponsavelConfigWhatsapp()
    )
    await this.collection.listResponsavelConfigWhatsapp()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelConfigWhatsappCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelConfigWhatsapp()
    new CsvResponsavelConfigWhatsappSchema().downloadCsv(csv.all())
  }
}
